module.exports = __webpack_public_path__ + "4.dd77cc9a389082233e62.png";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/css/patterns/4.png
// module id = ../../../../../ng-src/assets/css/patterns/4.png
// module chunks = styles